// ═══════════════════════════════════════════════════════════════
// SelectorEmpresaStaff — dropdown de empresa para páginas que se
// filtran por empresa pero cuyo usuario staff NO tiene una empresa
// fija (empresaIds vacío). Carga las empresas según el alcance del rol
// (Wizard/Operaciones: todas; resto: sus asignadas) y es un <select>
// controlado (value + onChange).
//
// Para roles CLIENTE (empresa fija) no se usa: la página resuelve su
// empresaIds[0] y no muestra selector.
// ═══════════════════════════════════════════════════════════════
import { useState, useEffect } from 'react'
import { useAuth } from '@core/contexts/AuthContext'
import { cargarEmpresasSegunAlcance } from '@core/lib/alcanceEmpresas'
import { createLogger } from '@core/lib/logger'

const log = createLogger('SelectorEmpresaStaff')

export default function SelectorEmpresaStaff({ value, onChange, className }) {
  const { veTodasLasEmpresas, userDoc } = useAuth()
  const [empresas, setEmpresas] = useState([])

  useEffect(() => {
    let cancel = false
    cargarEmpresasSegunAlcance({ veTodasLasEmpresas, userDoc })
      .then(list => {
        if (cancel) return
        setEmpresas(
          list
            .map(e => ({ id: e.id, nombre: e.nombre || e.razonSocial || e.id }))
            .sort((a, b) => a.nombre.localeCompare(b.nombre))
        )
      })
      .catch(err => log.warn('empresas', err?.message))
    return () => { cancel = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDoc?.id, (userDoc?.empresaIds || []).join(',')])

  return (
    <select
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      title="Elegí la empresa a mostrar"
      className={className || 'bg-white/[0.04] border border-white/[0.08] rounded-lg px-3 py-1.5 text-sm text-zinc-200 focus:outline-none cursor-pointer min-w-[220px]'}
    >
      <option value="" className="bg-zinc-800">
        {empresas.length === 0 ? 'Sin empresas disponibles' : '— Elegir empresa —'}
      </option>
      {empresas.map(e => (
        <option key={e.id} value={e.id} className="bg-zinc-800">{e.nombre}</option>
      ))}
    </select>
  )
}
